export const AiIconForDarkMode = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Calque_1"
    data-name="Calque 1"
    viewBox="0 0 566.93 566.93"
  >
    <defs>
      <style>{'.cls-2{fill:#1d1d1b}'}</style>
    </defs>
    <path
      d="M272.03 100.72c100.92 0 182.74 81.82 182.74 182.75s-81.82 182.74-182.74 182.74S89.28 384.39 89.28 283.47s81.82-182.75 182.75-182.75"
      style={{
        fill: '#fff',
        fillRule: 'evenodd',
      }}
    />
    <path
      d="M170.79 353.74c-1.08 0-2.05-.43-2.92-1.31-.88-.87-1.31-1.84-1.31-2.92 0-.67.07-1.27.2-1.81l47.34-129.32q.6-2.22 2.52-3.93 1.905-1.71 5.34-1.71h29.81q3.42 0 5.34 1.71 1.905 1.71 2.52 3.93l47.14 129.32c.27.54.4 1.14.4 1.81 0 1.08-.44 2.05-1.31 2.92s-1.91 1.31-3.12 1.31h-24.78c-2.01 0-3.52-.5-4.53-1.51s-1.65-1.91-1.91-2.72l-7.86-20.55h-53.78l-7.65 20.55c-.27.81-.88 1.71-1.81 2.72-.94 1.01-2.55 1.51-4.83 1.51h-24.78Zm47.34-53.78h37.47l-18.93-53.18-18.53 53.18ZM328.11 353.74q-2.22 0-3.63-1.41t-1.41-3.63V217.77c0-1.48.47-2.68 1.41-3.63s2.15-1.41 3.63-1.41h26.99c1.48 0 2.68.47 3.63 1.41q1.41 1.41 1.41 3.63V348.7q0 2.22-1.41 3.63t-3.63 1.41z"
      className="cls-2"
    />
  </svg>
);
